<span class = "error">
  {{error}}
</span>